import { ClipboardList, CreditCard, Inbox, PlayCircle } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

const STEPS = [
  { icon: ClipboardList, title: "Choose your plan", desc: "Pick the subscription that suits you best." },
  { icon: CreditCard, title: "Place your order", desc: "Fill in the quick order form — it takes a minute." },
  { icon: Inbox, title: "Receive setup instructions", desc: "We send simple, step-by-step guidance fast." },
  { icon: PlayCircle, title: "Start streaming", desc: "Sit back and enjoy your entertainment hub." },
];

export default function HowItWorks() {
  return (
    <section id="how" className="section-fade py-16 md:py-28" data-testid="how-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="How it works"
          title="Streaming in four simple steps"
          sub="No complications, no waiting around — from plan to play in minutes."
        />
        <div className="relative grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="absolute left-0 right-0 top-10 hidden border-t border-dashed border-electric/20 lg:block" aria-hidden="true" />
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.12} className="relative">
              <div className="group text-center lg:text-left" data-testid={`step-${i + 1}`}>
                <div className="relative z-10 mx-auto mb-6 inline-flex h-20 w-20 items-center justify-center rounded-2xl border border-electric/25 bg-surface text-electric shadow-[0_0_24px_rgba(0,240,255,0.15)] transition-all duration-300 group-hover:shadow-[0_0_36px_rgba(0,240,255,0.3)] lg:mx-0">
                  <s.icon className="h-8 w-8" />
                  <span className="absolute -right-2 -top-2 rounded-lg bg-electric px-2 py-0.5 font-mono text-[10px] font-bold text-slate-900">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-lg font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
